import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

import { Response, OpportunityContract, OpportunityContractRequest } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class OpportunityContractService {

  constructor(private http: HttpClient) { }

  update(request: OpportunityContractRequest): Observable<Response<OpportunityContract>> {
    return this.http.post<Response<OpportunityContract>>(environment.apiUrl + '/api/OpportunityContract/Update', request);
  }

  get(uuid: string): Observable<Response<OpportunityContract>> {
    const headers = new HttpHeaders({ 'content-type': 'application/json' });
    return this.http.post<Response<OpportunityContract>>(environment.apiUrl + '/api/OpportunityContract/Get', JSON.stringify(uuid), { headers });
  }

  sendForApproval(uuid: string): Observable<Response<OpportunityContract>> {
    const headers = new HttpHeaders({ 'content-type': 'application/json' });
    return this.http.post<Response<OpportunityContract>>(environment.apiUrl + '/api/OpportunityContract/SendForApproval', JSON.stringify(uuid), { headers });
  }
}
